let MATRIX_INTEGRATION_XID = {
  type: 'Matrix',
  key: 'orgXid',
  value: ''
};

export default MATRIX_INTEGRATION_XID;



// WEBPACK FOOTER //
// ./app/models/matrixIntegrationXid.js